<div class="title">
  {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.OMA_FUNCTION.HEADER' | translate }}
</div>

<div
  class="full-width flex flex-row lt-md:flex-col gap-[24px] xs:gap-[16px] justify-start items-start"
>
  <div class="lt-md:!hidden flex-[100%] max-w-[50%]"></div>

  <div class="full-width flex-1">
    <div class="radio-btns">
      <mat-radio-group
        name="transfer-option"
        class="flex flex-col"
        aria-label="Select transfer installation option"
        [disabled]="gatewayCommissioningStore.transferInstallationLoading$ | async"
      >
        <mat-radio-button
          gtm="onDeactivate"
          gtmAction="Grandma function"
          gtmCategory="gatewayCommissioning"
          class="radio-btn"
          name="end-user-transfer"
          [value]="false"
          [checked]="!isGrandmaFunctionSelected"
          (click)="onGrandmaFunctionToggle(false)"
          ><span class="radio-text">{{
            '+GATEWAY_COMMISSIONING.RADIO_BTN.TRANSFER_TO_END_CUSTOMER' | translate
          }}</span></mat-radio-button
        >
        <mat-radio-button
          gtm="onActivate"
          gtmAction="Grandma function"
          gtmCategory="gatewayCommissioning"
          class="radio-btn"
          name="oma-transfer"
          [value]="true"
          [checked]="isGrandmaFunctionSelected"
          (click)="onGrandmaFunctionToggle(true)"
          ><span class="radio-text">{{
            '+GATEWAY_COMMISSIONING.RADIO_BTN.TRANSFER_AS_OMA' | translate
          }}</span></mat-radio-button
        >
      </mat-radio-group>
    </div>

    <ng-container *ngIf="!isGrandmaFunctionSelected">
      <form class="full-width" [formGroup]="emailFormGroup" data-at-provide-email>
        <div class="title">
          {{ '+GATEWAY_COMMISSIONING_REDESIGN.EMAIL_ADDRESS' | translate }}
        </div>
        <div class="flex flex-col justify-center items-center">
          <mat-form-field mat-input-height-large-label class="full-width">
            <mat-label>{{ '+PROFILE.DETAILS.EMAIL' | translate }}</mat-label>
            <input
              gtm="onTextField"
              gtmId="email"
              gtmAction="Email"
              gtmCategory="gatewayCommissioningEmailForm"
              [gtmOn]="['change', 'focus', 'blur']"
              type="email"
              name="email"
              matInput
              formControlName="email"
              data-end-user-email-input
              ngDefaultControl
            />
            <mat-error *ngIf="emailFormGroup.controls.email?.errors?.pattern">{{
              '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.EMAIL.ERROR.PATTERN' | translate
            }}</mat-error>
            <mat-error *ngIf="emailFormGroup.controls.email?.errors?.required">{{
              '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.EMAIL.ERROR.REQUIRED' | translate
            }}</mat-error>
          </mat-form-field>
          <div class="mandatory-description">
            <sup>*</sup>
            {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.MANDATORY_FIELDS' | translate }}
          </div>
        </div>
      </form>
    </ng-container>

    <ng-container *ngIf="isGrandmaFunctionSelected">
      <form [formGroup]="omaFormGroup" data-at-provide-email>
        <div class="title">
          {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.OMA.HEADER' | translate }}
        </div>
        <div class="sub-title">
          {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.OMA.SUB_HEADER' | translate }}
        </div>
        <div class="flex flex-col justify-start items-start">
          <mat-radio-group
            class="radio-btns-oma-function flex flex-row gap-[12px]"
            aria-label="Select salutation"
            gtm="onChange"
            gtmAction="Oma salutation"
            gtmCategory="gatewayCommissioning"
            (change)="onSalutationToggle($event)"
          >
            <mat-radio-button
              class="radio-btn"
              name="salutation"
              [value]="Salutation.Mr"
              [checked]="salutation === Salutation.Mr"
              ><span class="radio-text">{{ 'SALUTATION.MR' | translate }}</span></mat-radio-button
            >
            <mat-radio-button
              class="radio-btn"
              name="salutation"
              [value]="Salutation.Mrs"
              [checked]="salutation === Salutation.Mrs"
            >
              <span class="radio-text">{{ 'SALUTATION.MRS' | translate }}</span></mat-radio-button
            >
          </mat-radio-group>

          <mat-form-field mat-input-height-large-label class="full-width">
            <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.NAME' | translate }}</mat-label>
            <input
              gtm="onTextField"
              gtmId="firstName"
              gtmAction="FirstName"
              gtmCategory="gatewayCommissioningOMAForm"
              [gtmOn]="['change', 'focus', 'blur']"
              name="firstName"
              formControlName="firstName"
              matInput
              data-at-oma-first-name-input
            />
            <mat-error *ngIf="omaFormGroup.controls.firstName?.errors?.required">
              {{
                '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.OMA.VALIDATION.FIRST_NAME_REQUIRED'
                  | translate
              }}
            </mat-error>
          </mat-form-field>

          <mat-form-field mat-input-height-large-label class="full-width">
            <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.LAST_NAME' | translate }}</mat-label>
            <input
              gtm="onTextField"
              gtmId="lastName"
              gtmAction="LastName"
              gtmCategory="gatewayCommissioningOMAForm"
              [gtmOn]="['change', 'focus', 'blur']"
              name="lastName"
              formControlName="lastName"
              matInput
              data-at-oma-last-name-input
            />
            <mat-error *ngIf="omaFormGroup.controls.lastName.errors?.required">{{
              '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.OMA.VALIDATION.LAST_NAME_REQUIRED'
                | translate
            }}</mat-error>
          </mat-form-field>
          <div class="mandatory-description">
            <sup>*</sup>
            {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.MANDATORY_FIELDS' | translate }}
          </div>
          <mat-checkbox
            class="checkbox-wrapper"
            name="isAccepted"
            formControlName="isAccepted"
            gtm="onSelect"
            gtmAction="On written consent acceptance"
            gtmCategory="gatewayCommissioningOMAForm"
          >
            <span class="checkbox-text"
              >{{
                '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.OMA.WRITTEN_CONSENT_AGREEMENT'
                  | translate
              }}
              <a
                target="_blank"
                data-at-private-policy-link
                href="https://api.viessmann-climatesolutions.com/legal/v3/documents/6f70a726-400b-4f60-b282-9ffed6a85521/download"
              >
                {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.OMA.WRITTEN_CONSENT' | translate }}
              </a></span
            >
          </mat-checkbox>
          <mat-error
            class="acceptance-required-warning"
            *ngIf="!omaFormGroup.controls.isAccepted.value"
          >
            {{
              '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.OMA.VALIDATION.ACCEPTANCE_REQUIRED'
                | translate
            }}
          </mat-error>
          <ng-container *ngIf="dataUsageAgreementDocument$ | async as document">
            <mat-checkbox
              class="checkbox-wrapper"
              name="isDataUsageAgreementAccepted"
              formControlName="isDataUsageAgreementAccepted"
              gtm="onSelect"
              gtmAction="On data usage agreement acceptance"
              gtmCategory="gatewayCommissioningOMAForm"
            >
              <span class="checkbox-text"
                >{{
                  '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.OMA.DATA_USAGE_AGREEMENT'
                    | translate
                }}
                <a
                  target="_blank"
                  data-at-data-usage-link
                  [href]="document.link"
                  rel="noopener noreferrer"
                >
                  {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.OMA.DATA_USAGE' | translate }}
                </a></span
              >
            </mat-checkbox>
            <mat-error
              class="acceptance-required-warning"
              *ngIf="!omaFormGroup.controls.isDataUsageAgreementAccepted.value"
            >
              {{
                '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.OMA.VALIDATION.DATA_USAGE_REQUIRED'
                  | translate
              }}
            </mat-error>
          </ng-container>
        </div>
      </form>
    </ng-container>
  </div>
</div>
